import React from 'react';
import classnames from 'classnames';
import { accent, darkBgPrimary } from 'scy/text/styles.mod.scss';
import PinIcon from 'images/icons/logos/pin.svg?react-svg';
import UserAvatar from 'scy/UserAvatar';
import { relative } from 'scy/position.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import { useBackground } from 'scy/Background';
import styles from './styles.mod.scss';

export default function Avatar({ user }) {
  const background = useBackground();

  return (
    <div
      className={classnames(relative, inlineBlock, {
        [darkBgPrimary]: background.isMuted,
        [accent]: !background.isMuted
      })}
    >
      <PinIcon width={84} height={114} />
      <UserAvatar user={user} large className={styles.avatar} />
    </div>
  );
}
